import React from "react";
import GroupSetting from "Components/GroupSetting/";
import useGroupSetting from "Hooks/useGroupSetting";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import { withRouter } from "react-router";
import googleAnalytics from "fuction/googleAnalytics";

function Group(props) {
  const { request } = useApi();
  const groupSetting = useGroupSetting();
  const auth = useAuth();
  const [id, setId] = React.useState(0);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 収集グループ設定";

    groupSetting.clearFlags();
    groupSetting.clearErrors();
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    if (auth.state.groups.length <= 0) {
      return;
    }

    const activeGroup = auth.state.groups.find(
      (group) => group.id === auth.state.activeGroup
    );

    setId(activeGroup.id);
    groupSetting.setAllData(activeGroup);
  }, [auth.state.groups]);

  const deleteGroup = () => {
    request({
      method: "DELETE",
      url: `config/:account_id/groups/${id}`,
    }).then((result) => {
      auth.deleteGroup(id);
      props.history.push("/dashboard");
    });
  };

  return (
    <GroupSetting
      handleSubmit={() => {
        groupSetting.editSubmit(id);
      }}
      state={groupSetting.state}
      isEdit={true}
      deleteGroup={deleteGroup}
    />
  );
}

export default withRouter(Group);
